import { FieldMetaState } from 'react-final-form';

interface IShowErrorProps {
  meta: FieldMetaState<any>;
}

export function showError({
  meta: { submitError, dirtySinceLastSubmit, error, touched, modified },
}: IShowErrorProps) {
  return !!(((submitError && !dirtySinceLastSubmit) || error) && (touched || modified));
}

export const showErrorOnChange = ({
  meta: { submitError, dirtySinceLastSubmit, error, touched, modified },
}: any) => ((submitError && !dirtySinceLastSubmit) || error) && (touched || modified);

export const showErrorOnBlurOrDirty = ({
  meta: { submitError, dirtySinceLastSubmit, error, touched, dirty },
}: any) => (((submitError && !dirtySinceLastSubmit) || error) && touched) || dirty;

/**
 * This helper can be used to make react-final-form format all
 * nullish values as empty string in form fields.
 *
 * @note This should be assigned to the "format" property on "fieldProperties"
 * on any input that should have this behavior.
 */
export function formatNullToEmpty(value: any): any {
  if (value === null || value === undefined) {
    return '';
  }
  return value;
}

/**
 * This helper can be used to make react-final-form parse all
 * empty strings as "null" in form fields.
 *
 * @note This should be assigned to the "parse" property on "fieldProperties"
 * on any input that should have this behavior.
 */
export function parseEmptyToNull(value: any): any {
  if (value === '') {
    return null;
  }

  return value;
}
